export enum TrailFinderAnswerRelations {
  question = 'question',
}
